import {Component, inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {WINDOW} from '../../../config/module.di.tokens';
import {environment} from '../../../../environments/environment';
import {RouterLink} from '@angular/router';
import {LpCtaComponent} from '../../common/lp/lp-cta/lp-cta.component';

@Component({
  selector: 'app-home-lets-meet',
  imports: [
    RouterLink,
    LpCtaComponent
  ],
  templateUrl: './home-lets-meet.component.html',
})
export class HomeLetsMeetComponent {

  window = inject(WINDOW)
  platformId = inject(PLATFORM_ID)

    viewBoxWidth() {

      let width = 1350
      if (isPlatformBrowser(this.platformId)) {
        if (this.window.innerWidth <= 768) {
          width = 350
        } else if (this.window.innerWidth <= 1280) {
          width = 750
        }
      }
      return width
    }

  protected readonly environment = environment;
}
